import LocaleReceiver from './LocaleReceiver';
export default LocaleReceiver;
